import * as React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SecureYourAppointment() {
  return <section id="secure-your-appointment" className="dark bg-background text-foreground py-16 sm:py-24 px-4 sm:px-6 lg:px-8 flex justify-center items-center">
      <div className="w-full max-w-6xl mx-auto">
        <div className="relative overflow-hidden border-[4px] border-primary rounded-xl bg-card p-8 sm:p-16 md:p-24 text-center flex flex-col items-center justify-center gap-8 sm:gap-12 shadow-2xl shadow-primary/5">
          {}
          <div className="absolute inset-0 opacity-40 pointer-events-none bg-[linear-gradient(45deg,#000_25%,transparent_25%,transparent_75%,#000_75%,#000),linear-gradient(45deg,#000_25%,transparent_25%,transparent_75%,#000_75%,#000)] bg-[length:8px_8px] bg-[position:0_0,4px_4px]" aria-hidden="true" />

          {}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,rgba(0,0,0,0.8)_100%)] pointer-events-none" />

          <h2 className="relative z-10 font-default text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold uppercase tracking-tighter text-white drop-shadow-[0_0_15px_rgba(255,255,255,0.1)] leading-none max-w-4xl">
            Ready For Perfection?
          </h2>

          <div className="relative z-10 w-full max-w-sm sm:max-w-md mx-auto mt-4">
            <Link to="https://app.urable.com/virtual-shop/RwwACfmUUCbP7DfYZWTj/CGFL6U746Nrm4S5dIlSG" className="w-full block focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background rounded-md">
              <Button size="lg" className="relative overflow-hidden group w-full h-16 sm:h-20 text-lg sm:text-xl font-bold uppercase tracking-widest bg-primary text-primary-foreground border-none transition-all duration-300 hover:scale-[1.02] hover:shadow-[0_0_40px_rgba(var(--color-primary),0.3)] rounded-md">
                {}
                <span className="absolute inset-0 bg-gradient-to-r from-primary via-[#f0e6d2] to-white opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-out" />

                {}
                <span className="relative z-10 group-hover:text-zinc-950 transition-colors duration-500 ease-out flex items-center justify-center gap-2">
                  Book Your Detail
                </span>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>;
}